import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ProgressCircleComponent {
  @Input() current = 0;
  @Input() diameter = 20;

  get completed() {
    return this.current === 100;
  }
}
